import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// POST /ajax/enrollment/manage_childcare_transaction_slots
export const manageTransactionChildcareSlots = async (
  enrollmentId: number,
  slotIds: number[]
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post('/ajax/enrollment/manage_childcare_transaction_slots', {
        enrollment_id: enrollmentId,
        slot_ids: slotIds
      })
      .then((response: any) => {
        // Core reports a refused change as a 200 with success=false (unknown or
        // foreign enrollment); that is a failure to the family, not a save.
        if (response?.data && response.data.success === false) {
          reject({
            reason: response.data.failure_reason ?? null,
            message:
              'Failed to manage transaction childcare slots: ' +
              (response.data.failure_reason ?? ''),
            cause: null
          })
          return
        }
        resolve(response.data)
      })
      .catch((err: any) => {
        // DTA-880: carry the server's plain reason (a past or billed session) to the family.
        reject({
          reason: err?.response?.data?.failure_reason ?? null,
          message:
            'Failed to manage transaction childcare slots: ' +
            (err?.response?.data?.failure_reason ?? err?.message ?? ''),
          cause: err
        })
      })
  })
}
